import { render, staticRenderFns } from "./ticket-number-table.vue?vue&type=template&id=76749420"
import script from "./ticket-number-table.vue?vue&type=script&lang=js"
export * from "./ticket-number-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76749420')) {
      api.createRecord('76749420', component.options)
    } else {
      api.reload('76749420', component.options)
    }
    module.hot.accept("./ticket-number-table.vue?vue&type=template&id=76749420", function () {
      api.rerender('76749420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ticket-number-table.vue"
export default component.exports